import { render, staticRenderFns } from "./GenderPanel.vue?vue&type=template&id=2df739a2&scoped=true&"
import script from "./GenderPanel.vue?vue&type=script&lang=ts&"
export * from "./GenderPanel.vue?vue&type=script&lang=ts&"
import style0 from "./GenderPanel.vue?vue&type=style&index=0&id=2df739a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df739a2",
  null
  
)

export default component.exports